// 路引信息修改相关数据
export const GUIDE_TYPE = {
  RECOMMEND: '推荐', // 推荐
  SUBWAYSTATION: '地铁', // 地铁
  BUSSTOP: '公交站', // 公交站
  SCENERY: '景区', // 景区
  SCHOOL: '学校', // 学校
  HOSPITAL: '医院', // 医院
  INTERSECTION: '交叉路', // 交叉路
  HOTEL: '酒店', // 酒店,
  POIITSELF: 'POIITSELF', // 商户本身
};
export const GUIDE_TYPE_RECOMMEND = 'RECOMMEND';    // 推荐
export const GUIDE_TYPE_POIITSELF = 'POIITSELF';    // 商户本身
export const GUIDE_TYPE_SUBWAYSTATION = 'SUBWAYSTATION';  // 地铁

export const GUIDE_IMG_URL = {
    SUBWAYSTATION: '//p1.meituan.net/dpgroup/aa13388bc4174eb2486430d2fad5daeb5310.png', // 地铁
    BUSSTOP: '//p1.meituan.net/dpgroup/7a42573aed2b960b5c622a8da8eb8de23730.png', // 公交站
    SCENERY: '//p1.meituan.net/dpgroup/3734a123a1fff8f0db0edc593e7418e53967.png', // 景区
    SCHOOL: '//p0.meituan.net/dpgroup/eb39557805f3461027144272256dc7294350.png', // 学校
    HOSPITAL: '//p0.meituan.net/dpgroup/3b99e0a3419dab6d2bc29d10c46ad4ff3757.png', // 医院
    INTERSECTION: '//p1.meituan.net/dpgroup/d2c385a4d071e6d3df25f82efc9a6a093476.png', // 交叉路
    HOTEL: '//p1.meituan.net/dpgroup/de6fa81a2cf70a110d7a0885bc0d6de33582.png', // 酒店,
    POIITSELF: '//p1.meituan.net/dpgroup/b393c30574614d3e8009dd69eb9c15e32468.png', // 商户本身
  };
export const  GUIDE_IMG_SELECTED_URL = {
    SUBWAYSTATION: '//p0.meituan.net/dpgroup/b55bc9e55c5deb6ce3d72eb3e9d2e1b75378.png',
    BUSSTOP: '//p0.meituan.net/dpgroup/0b232cb0a7374e4664cf4f50ff46b5ce5227.png',
    SCENERY: '//p0.meituan.net/dpgroup/60999d4c3bd2c0776c2e9f3cb42888265558.png',
    SCHOOL: '//p0.meituan.net/dpgroup/054ff2f3b19394da02036c13a90d8f625950.png',
    HOSPITAL: '//p0.meituan.net/dpgroup/883438c97d273acced4023fa92dda34f5212.png',
    INTERSECTION: '//p0.meituan.net/dpgroup/e095e29e5423faf3b429e6dc1a7d1b365063.png',
    HOTEL: '//p0.meituan.net/dpgroup/3645099fea08966c62ff3ccd11cc71b35191.png',
}